import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {HomeAway} from "../model/home-away";
import {calculateYardLine, getDistance} from "../helpers/distance";

export class SetPenaltyAfterPlayCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private penaltyForHome: boolean,
    private penaltyYard: number,
    private yardSpot: string
  ) { }

  execute() {
    console.log('COMMAND SetPenaltyAfterPlayCommand', this.gamePlay, this.penaltyYard, this.penaltyForHome, this.yardSpot)

    //TODO : il faudrait avoir le yardRetourner spot pour être en mesure de calculer le nombre de verge de pénalité correctement
    //  Seb : Si la personne la saisie... sinon on met le nombre de verge que la personne a saisie lors de l'entrée de la pénalité.

    // FIXME Retirer le if pour corriger [PT FG] FgAttemptComponent - Pénalité after play
    //  if (![PlayType.FG, PlayType.FGBlock].includes(this.gamePlay.playType!) ) {
    // Voir SetPenaltyCommand : penaltyYard === 0 sans yardSpot = résultat sans verges (firstDown/loosDown), pas un spot foul.
    this.gamePlay.penYards = (this.penaltyYard === 0 && this.yardSpot !== '')
      ? this.calculatePenaltyYards(this.penaltyYard, this.yardSpot)
      : this.penaltyYard

    if (this.gamePlay.penYards < 0) {
      // On met toujours le nombre en positif
      this.gamePlay.penYards = this.gamePlay.penYards * -1;
    }

    this.gamePlay.penTeam = this.penaltyForHome ? HomeAway.Home : HomeAway.Away
  }

  calculatePenaltyYards(penaltyYard: number, yardSpot: string): number {
    const playSpot = calculateYardLine(this.gamePlay.yardLine, this.gamePlay.gnLs!)
    return getDistance(playSpot, yardSpot)
  }
}
